/**
 * @file The select account identity container.
 */

import { connect } from 'react-redux';

import SelectAccountIdentity from '../../components/purchase/SelectAccountIdentity';
import {
  selectIdentityForPurchase,
  deselectIdentityForPurchase,
  selectIdentityForJoin,
  deselectIdentityForJoin,
} from '../../actions/purchase-album';
import { getUploadedPhotoByIdentity } from '../../util/photo-upload';
import { openModal } from '../../actions/modal-actions';

const mapStateToProps = ({ photoUploads }, ownProps) => ({
  uploadedPhoto: getUploadedPhotoByIdentity(
    photoUploads.photos,
    ownProps.identity,
  ),
});

const mapDispatchToProps = {
  selectIdentityForPurchase,
  deselectIdentityForPurchase,
  selectIdentityForJoin,
  deselectIdentityForJoin,
  openModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectAccountIdentity);
